import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

export const useIsChangingRoute = () => {
  const [isChangingRoute, setIsChangingRoute] = useState(false)
  const router = useRouter()

  useEffect(() => {
    const handleRouteChangeStart = () => setIsChangingRoute(true)
    const handleRouteChangeEnd = () => setIsChangingRoute(false)

    router.events.on('routeChangeStart', handleRouteChangeStart)
    router.events.on('routeChangeComplete', handleRouteChangeEnd)
    router.events.on('routeChangeError', handleRouteChangeEnd)

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart)
      router.events.off('routeChangeComplete', handleRouteChangeEnd)
      router.events.off('routeChangeError', handleRouteChangeEnd)
    }
  }, [router.events])

  return isChangingRoute
}
